export const withoutWeightColor = ['inherit', 'current', 'transparent', 'black', 'white'];
